import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'

import styles from 'src/styles/common.module.scss'

export const TextHeaderEs = () => {
    return (
        <HighlightedText
            text="¡FELICIDADES!"
            highlights={[{ word: '¡FELICIDADES!' }]}
            className={styles.text_header}
        />
    )
}

export const TextContentEs = () => {
    return (
        <HighlightedText
            text="HAS GANADO 400 GIROS GRATIS"
            highlights={[
                { word: '400' },
                { word: 'GIROS' },
                { word: 'GRATIS' },
            ]}
            breakAfterWords={['GANADO']}
            className={styles['text_content--SECOND']}
        />
    )
}
